import useProtoMethod from "./useProtoMethod";
import {
  CreateMemberInquiryRequest,
  CreateMemberInquiryResponse,
  FetchAdvisorPublicProfileRequest,
  FetchAdvisorPublicProfileResponse,
  ResolveFamilyExportRequest,
  ResolveFamilyExportResponse,
} from "protogen/public_service_pb";

const useFetchPublicAdvisorProfile = (
  callback?: (r: FetchAdvisorPublicProfileResponse) => void,
) => {
  return useProtoMethod<
    FetchAdvisorPublicProfileRequest,
    FetchAdvisorPublicProfileResponse
  >("FetchPublicAdvisorProfile", FetchAdvisorPublicProfileResponse, {
    callback,
  });
};

const useCreateMemberInquiry = (
  callback?: (r: CreateMemberInquiryResponse) => void,
) => {
  return useProtoMethod<
    CreateMemberInquiryRequest,
    CreateMemberInquiryResponse
  >("CreateMemberInquiry", CreateMemberInquiryResponse, {
    callback,
  });
};

const useResolveFamilyExport = () => {
  return useProtoMethod<
    ResolveFamilyExportRequest,
    ResolveFamilyExportResponse
  >("ResolveFamilyExport", ResolveFamilyExportResponse);
};

export {
  useFetchPublicAdvisorProfile,
  useCreateMemberInquiry,
  useResolveFamilyExport,
};
